export default "__VITE_ASSET__DuBTBmJN__"